const formatQuestionnaireNumber = (args: {
  text: string;
  seperator?: string;
}): string => {
  return String(args.text).replace(
    /\B(?=(\d{3})+(?!\d))/g,
    args.seperator || "'"
  );
};

export { formatQuestionnaireNumber };
